import { FormikErrors } from 'formik';
import { pluralize } from '~/utils';

import { MAX_TAGS, MIN_TAGS } from './Experience.constants';
import { ExperienceValues } from './Experience.types';

export const ExperienceValidate = (fields: ExperienceValues) => {
  let errors: FormikErrors<ExperienceValues> = {};
  if (fields.experienceTags?.length < MIN_TAGS) {
    errors.experienceTags = `Min. ${MIN_TAGS} ${pluralize(
      'brand',
      'brands',
      MIN_TAGS,
    )}`;
  }
  if (fields.experienceTags.length > MAX_TAGS) {
    errors.experienceTags = `Max. ${MAX_TAGS} ${pluralize(
      'brand',
      'brands',
      MAX_TAGS,
    )}`;
  }
  return errors;
};
